export const GUEST_USER_ID = 'guest';

export function isGuest(user: { id: string } | null | undefined): boolean {
  return user?.id === GUEST_USER_ID;
}
